export default __webpack_public_path__ + "static/media/man-with-targets-as-destinations.9cd802a0.svg";